import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { Filters } from 'types/filters';

import { AppModules } from 'constants/enums';

interface ModuleConfig {
  filters: Partial<Filters>;
  isFiltersLoading: boolean;
}

export interface ModuleConfigsState {
  configs: {
    [key in AppModules]?: ModuleConfig;
  };
  activeModule: AppModules | null;
}

const initialState: ModuleConfigsState = {
  configs: {},
  activeModule: null
};

const moduleConfigsSlice = createSlice({
  name: 'moduleConfigs',
  initialState,
  reducers: {
    setModuleConfig(
      state,
      action: PayloadAction<{
        module: AppModules;
        config: ModuleConfig;
      }>
    ) {
      const { module, config } = action.payload;
      state.configs[module] = config;
    },
    updateModuleFilters(
      state,
      action: PayloadAction<{
        module: AppModules;
        filters: Partial<Filters>;
      }>
    ) {
      const { module, filters } = action.payload;

      if (!state.configs[module]) {
        state.configs[module] = {
          filters: {},
          isFiltersLoading: false
        };
      }
      state.configs[module]!.filters = filters;
    },
    setActiveModule(state, action: PayloadAction<AppModules>) {
      state.activeModule = action.payload;
    },
    setFiltersLoading(
      state,
      action: PayloadAction<{ module: AppModules; isLoading: boolean }>
    ) {
      const { module, isLoading } = action.payload;

      if (!state.configs[module]) {
        state.configs[module] = {
          filters: {},
          isFiltersLoading: false
        };
      }
      state.configs[module]!.isFiltersLoading = isLoading;
    },
    initializeModuleConfig(state, action: PayloadAction<AppModules>) {
      const module = action.payload;
      if (!state.configs[module]) {
        state.configs[module] = {
          filters: {},
          isFiltersLoading: false
        };
      }
    }
  }
});

export const {
  setModuleConfig,
  updateModuleFilters,
  setActiveModule,
  setFiltersLoading,
  initializeModuleConfig
} = moduleConfigsSlice.actions;

export default moduleConfigsSlice.reducer;
